// 该文件由 AI 生成。请勿直接编辑。
// 基于后端 schemas 为客户端生成 TypeScript 类型。
// 注意: Date 类型已转换为 string。

/**
 * 道具状态
 * 'enabled': 启用
 * 'disabled': 禁用
 */
export enum PropStatus {
	ENABLED = "enabled",
	DISABLED = "disabled",
}

/**
 * 道具定义类型
 * 用于客户端展示和交互。
 */
export interface Prop {
	id: string
	name_trans: Record<string, string>
	alias?: string | null
	startTime?: string | null
	endTime?: string | null
	expiresIn?: string | null
	status: PropStatus
	icon_trans?: Record<string, string> | null
	description_trans?: Record<string, string> | null
	stackable: boolean
	extensionType?: string | null
	extensionId?: string | null
	createdAt: string
	updatedAt: string
	deletedAt?: string | null
}

/**
 * 用户道具状态枚举
 * 'available': 可用
 * 'consumed': 已核销/已消耗
 * 'locked': 锁定
 * 'expired': 已过期
 */
export enum UserPropStatus {
	AVAILABLE = "available",
	CONSUMED = "consumed",
	LOCKED = "locked",
	EXPIRED = "expired",
}

/**
 * 用户拥有的道具类型
 * 用于客户端展示和管理用户的道具。
 */
export interface UserProp {
	id: string
	propId: string
	userId: string
	quantity: number
	status: UserPropStatus
	startTime?: string | null
	endTime?: string | null
	lockUntil?: string | null
	extraData?: Record<string, any> | null
	createdAt: string
	updatedAt: string
	deletedAt?: string | null
}

/**
 * 带锁更新多个用户道具状态操作的输出类型。
 */
export interface UpdateUserPropsStatusWithLockOutput {
	success: boolean
	updatedProps: UserProp[]
	failedPropIds: string[]
}

// 注意:
// - `propRpcRouter.public_findPropIdsByExtension` 的输出类型是 `string[]`，不需要特定接口。
// - `userPropRpcRouter.checkHasProps` 的输出类型是 `boolean`，不需要特定接口。
